import { MutationOptions, useMutation } from "react-query";
import { API_URL, APIError, APIResponse, post } from "../api";
import { User } from "../@types";

type LoginVariables = {
  email: string;
  password: string;
};

type LoginResponse =
  | {
      token: string;
      user: User;
      nextStep?: string;
      stage?: string;
      funnelStep?: number;
    }
  | string;
// Authenticator challenge intentionally carries no access token.
type AuthenticatorChallenge = {
  public_id: string;
  method: "authenticator";
  expires_in: number;
};

function useLogin(
  options?: MutationOptions<
    APIResponse<LoginResponse | AuthenticatorChallenge>,
    APIError,
    LoginVariables
  >,
) {
  const {
    isLoading,
    isError,
    error,
    mutate: login,
  } = useMutation<
    APIResponse<LoginResponse | AuthenticatorChallenge>,
    APIError,
    LoginVariables
  >(async (variables) => {
    return await post(API_URL + "/auth/user/login", variables, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }, options);

  return {
    login,
    isLoading,
    isError,
    error,
  };
}

export default useLogin;
